import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
/**
 * Services that stores stuff in Session Storage, with easy USUABLE functions
 */
export class SessionStorageService {

  /** Set the name of the column you are Sorting By */
  public get sortingColumnName(): string {
    return this._sortingColumnName;
  };

  /** Holds the name of the column you are Sorting By */
  public set sortingColumnName(value: string) {
    this._sortingColumnName = value;
    sessionStorage.setItem("SortingColumn", this.sortingColumnName);
  };

  /** Set whether you are sorting by Descending (true)  or Ascending (false) */
  public set sortDescending(descendingDirection: boolean) {
    this._sortDescending = descendingDirection;
    sessionStorage.setItem("SortingDirection", this.sortingDirection);
  }
  /** Get the Sorting Direction as String (desc / asc) */
  public get sortingDirection(): string {
    if (this._sortDescending) {
      return this.descendingDirection;
    }
    return this.ascendingDirection;
  }

  private descendingDirection: string = "desc"
  private ascendingDirection: string = "asc"
  private _sortDescending: boolean = false;
  private _sortingColumnName: string = "";

  constructor() {
    // get initial stored columnname
    let columnName = sessionStorage.getItem("SortingColumn");
    if (!columnName) {
      this._sortingColumnName = "lastUpdate"
    } else {
      this._sortingColumnName = columnName!;
    }
    // get initial stored direction
    let direction = sessionStorage.getItem("SortingDirection");
    if (!direction) {
      this._sortDescending = true
    } else {
      this._sortDescending = (direction == this.descendingDirection);
    }
  }

}